import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

import {
  getDeptDropdown,
  getFrequencyTypeDropdown,
  getFrequencyUnitDropdown,
  getPostAssessmentDropdown,
  getPreAssessmentDropdown,
  getRiskLevelDropdown,
  getRoleDropdown,
  getTrainingTypeDropdown,
  getUnitDropdown,
  saveTrainingMaster,
  updateTrainingMaster,
} from "../../services/Training/TrainingMasterServices";
import { CloseModalIcon } from "../../../../../common/components/assets/commonassets/CommonAssets";
import CommonDivider from "../../../../../common/components/divider/CommonDivider";
import InputField from "../../../../../common/components/FormFields/InputField";
import DropdownField from "../../../../../common/components/FormFields/DropdownField";
import CheckBoxField from "../../../../../common/components/FormFields/CheckBoxField";
import { DeleteIcon } from "../../../../../assets/CommonAssets";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../../../common/components/ConfirmationModal";
import { CapitalizeStatement } from "../../../../../common/components/Custom Hooks/CapitalizeStatement";
import {
  errorAlert,
  successAlert,
} from "../../../../../common/components/Toasts/CustomToasts";
import { getDepartmentDropdown } from "../../services/Group/GroupServices";

const userActions = [
  {
    id: 0,
    permission: "Edit",
    isAction: true,
  },
  {
    id: 1,
    permission: "Delete",
    isAction: true,
  },
  {
    id: 2,
    permission: "Create",
    isAction: false,
  },
];
const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "75vh",
  minHeight: "55vh",
  bgcolor: "background.paper",
  border: "1px solid gray",
  overflowY: "scroll",
  boxShadow: 20,
  p: 2,
};
{
  /* jci mendatory frequency periodic rule change type drop, frequency interval ,frequency unit drop : days ,months year */
}
const schema = yup?.object().shape({
  training: yup?.string().trim().required("Training name is required"),
  description: yup?.string().trim().required("Description name is required"),
  preAssessmentDrop: yup
    .object()
    .nullable()
    .when("preAssessment", {
      is: true,
      then: (schema) => schema?.required("Pre Assessment is required"),
      otherwise: (schema) => schema?.nullable(),
    }),

  postAssessmentDrop: yup
    .object()
    .nullable()
    .when("postAssessment", {
      is: true,
      then: (schema) => schema?.required("Post Assessment is required"),
      otherwise: (schema) => schema?.nullable(),
    }),
  validityPeriod: yup
    .number()
    .typeError("Validity period must be a number")
    .positive("Validity period must be greater than 0")
    .required("Validity period is required"),
  NABHChapter: yup?.string().when("NABHmandatory", {
    is: true,
    then: (schema) => schema?.trim().required("NABH Chapter is required"),
    otherwise: (schema) => schema?.notRequired(),
  }),

  NABHClause: yup?.string().when("NABHmandatory", {
    is: true,
    then: (schema) => schema?.trim().required("NABH Clause is required"),
    otherwise: (schema) => schema?.notRequired(),
  }),

  NABHDescription: yup?.string().when("NABHmandatory", {
    is: true,
    then: (schema) => schema?.trim().required("NABH Description is required"),
    otherwise: (schema) => schema?.notRequired(),
  }),

  riskLevel: yup
    .object()
    .nullable()
    .when("NABHmandatory", {
      is: true,
      then: (schema) => schema?.required("Risk Level is required"),
      otherwise: (schema) => schema?.notRequired(),
    }),
  // applicableRoles: yup
  //   .array()
  //   .min(1, "Select at least one role")
  //   .required("Applicable roles are required"),

  // applicableDepartment: yup
  //   .array()
  //   .min(1, "Select at least one department")
  //   .required("Applicable department is required"),

  passing: yup
    .number()
    .typeError("Passing must be a number")
    .min(0, "Passing cannot be less than 0")
    .max(100, "Passing cannot exceed 100")
    .required("Passing is required"),

  attempts: yup
    .number()
    .typeError("Attempts must be a number")
    .min(1, "Minimum 1 attempt required")
    .required("Max attempts is required"),
  // unit: yup?.object().nullable().required("Unit type is required"),
  trainingType: yup?.object().nullable().required("Training type is required"),
});
const defaultValues = {
  // Basic
  training: "",
  description: "",

  // Checkboxes
  mandatory: false,
  NABHmandatory: false,
  JCIMendetory: false,

  // NABH fields (conditionally required)
  NABHChapter: "",
  NABHClause: "",
  NABHDescription: "",
  riskLevel: null,

  // Frequency
  frequencyType: null,
  frequencyInterval: "",
  frequencyUnit: null,

  // Validity & Applicability
  validityPeriod: "",
  applicableRoles: [],
  applicableDepartment: [],

  // Assessment
  assessmentReq: false,
  preAssessment: false,
  postAssessment: false,
  preAssessmentDrop: null,
  postAssessmentDrop: null,

  // Passing Criteria
  passing: "",
  attempts: "",

  // Training Type
  trainingType: null,
};


const TrainingModal = ({
  setTrainingModalOpen,
  trainingModalOpen,
  selectedRow,
  setSelectedRow,
  populateTable,
  setOpenBackdrop,
  openBackDrop,
  coursesData,
  setCoursesData,
  setSelectedRowDetail,
}) => {
  const {
    handleSubmit,
    reset,
    control,
    watch,
    formState: { errors },
    setValue,
  } = useForm({ defaultValues, resolver: yupResolver(schema) });
  const getUserInfo = JSON.parse(localStorage?.getItem("loggedUser"));
  // const unit = getUserInfo?.units?.length > 0 ? getUserInfo?.units : [];
  let watchUnit = watch("unit");
  const [finalData, setFinalData] = useState([]);
  const [openPostModal, setOpenPostModal] = useState(false);
  const [riskLevelDropdown, setRiskLevelDropdown] = useState([]);
  const [frequencyTypeDropdown, setfrequencyTypeDropdown] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [frequencyUnitDropdown, setfrequencyUnitDropdown] = useState([]);
  const [trainingTypeDropdown, setTrainingTypeDropdown] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [preAssessmentDropdown, setPreAssessmentDropdown] = useState([]);
  const [postAssessmentDropdown, setPostAssessmentDropdown] = useState([]);
  const [unitDropDown, setUnitDropdown] = useState([]);
  const [roleTypeDropdown, setRoleTypeDropdown] = useState([]);
  const assessmentReq = watch("assessmentReq");

  const selectedTrainingType = watch("trainingType");
  let NABHmandatory = watch("NABHmandatory");
  let preAssessment = watch("preAssessment");
  let postAssessment = watch("postAssessment");

  const [spinner, showSpinner] = React.useState(false);

  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader?.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader?.result?.split(",")[1];
        resolve(base64);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const onSubmit = async (formData) => {
    try {
      if (
        (selectedTrainingType?.id === 1 || selectedTrainingType?.id === 2) &&
        uploadedFiles?.length < 1
      ) {
        return errorAlert("Please select at least one document.");
      }
      const isVideo = formData?.trainingType?.label === "Video";
      const isDocument = formData?.trainingType?.label === "Document";

      const allFiles = isVideo || isDocument ? uploadedFiles : [];

      // Existing files (from backend) — sirf id jaayega
      // const existingDocs = allFiles
      //   .filter((file) => file?.id) // backend wale objects
      //   .map((file) => ({
      //     id: file?.id,
      //   }));
      const existingDocs = allFiles
        .filter((file) => file?.id)
        .map((file) => ({
          id: file?.id,
          fileName: file?.fileName,
          path: file?.path,
          fileType: file?.fileType,
          isUpdate: true,
          deleteFlag: file?.deleteFlag,
        }));
      // Naye files — actual File object
      const newFiles = allFiles?.filter((file) => !file?.id);

      const finalObject = {
        id: selectedRow ? selectedRow?.id : 0,
        training: CapitalizeStatement(formData?.training),
        description: formData?.description?.trim(),
        mandatory: !!formData?.mandatory,
        nabhMandatory: !!formData?.NABHmandatory,
        jciMandatory: !!formData?.JCIMendetory,
        nabhChapter: formData?.NABHmandatory ? formData?.NABHChapter : null,
        nabhClause: formData?.NABHmandatory ? formData?.NABHClause : null,
        nabhDescription: formData?.NABHmandatory
          ? formData?.NABHDescription
          : null,
        riskLevel: formData?.riskLevel ? { id: formData?.riskLevel?.id } : null,
        frequencyType: formData?.frequencyType
          ? { id: formData?.frequencyType?.id }
          : null,
        frequencyInterval: formData?.frequencyInterval
          ? Number(formData?.frequencyInterval)
          : 0,
        frequencyUnit: formData?.frequencyUnit
          ? { id: formData?.frequencyUnit?.id }
          : null,
        validity: Number(formData?.validityPeriod),
        department:
          formData?.applicableDepartment?.map((d) => ({ id: d?.id })) || [],
        unit: formData?.unit ? { id: formData?.unit?.id } : null,
        trainingType: formData?.trainingType
          ? { id: formData?.trainingType?.id }
          : null,

        trainingDocumentRequestDtos: existingDocs,

        assessmentRequired: !!formData?.assessmentReq,
        preAssessmentRequired: !!formData?.preAssessment,
        postAssessmentRequired: !!formData?.postAssessment,
        preAssessment: formData?.preAssessmentDrop
          ? { id: formData?.preAssessmentDrop?.id }
          : null,
        noOfQuestionPreAssessment: formData?.preAssNoOfQuestions || null,
        noOfQuestionPostAssessment: formData?.postAssNoOfQuestions || null,
        postAssessment: formData?.postAssessmentDrop
          ? { id: formData?.postAssessmentDrop?.id }
          : null,
        passing: Number(formData?.passing),
        maxAttempt: Number(formData?.attempts),
      };

      setFinalData({
        data: finalObject,
        videoFiles: isVideo ? newFiles : [],
        documentFiles: isDocument ? newFiles : [],
      });

      console.log(finalObject, "finalObject");
      setOpenPostModal(true);
    } catch (error) {
      errorAlert("Error: " + error?.message);
    }
  };

  const handleSaveRecord = async () => {
    setOpenPostModal(false);
    setOpenBackdrop(true);

    try {
      const response =
        selectedRow !== null
          ? await updateTrainingMaster(finalData)
          : await saveTrainingMaster(finalData);

      const res = response?.data;

      if (res?.statusCode === 200 || res?.statusCode === 201) {
        successAlert(res?.message);
        populateTable();
        setSelectedRow(null);
        reset(defaultValues);
        setUploadedFiles([]);
        setTrainingModalOpen(false);
      }
    } catch (error) {
      errorAlert(error?.message);
    } finally {
      setOpenBackdrop(false);
    }
  };
  const renderActions = (row, index) => {
    return (
      <div className="flex gap-0 items-center">
        {userActions?.map((actions, i) => (
          <>
            {actions?.isAction === true ? (
              <div className="flex gap-2 cursor-pointer">
                {actions?.permission === "Delete" ? (
                  <DeleteIcon
                    sx={{ color: "#D11A2A" }}
                    type={"button"}
                    // onClick={() =>
                    //   setUploadedFiles((prev) =>
                    //     prev?.filter((_, i) => i !== index),
                    //   )
                    // }
                    onClick={() =>
                      setUploadedFiles((prev) =>
                        prev?.map((item, i) =>
                          i === index ? { ...item, deleteFlag: true } : item,
                        ),
                      )
                    }
                  />
                ) : null}
              </div>
            ) : null}
          </>
        ))}
      </div>
    );
  };

  const handleFileChange = (e) => {
    const files = Array.from(e?.target?.files);
    console.log(files, "files");
    setUploadedFiles((prev) => [...prev, ...files]);
  };

  useEffect(() => {
    if (!assessmentReq) {
      setValue("preAssessment", false);
      setValue("postAssessment", false);
      setValue("preAssessmentDrop", null);
      setValue("postAssessmentDrop", null);
    }
  }, [assessmentReq]);

  useEffect(() => {
    if (selectedRow !== null && trainingModalOpen) {
      // Basic fields
      setValue("training", selectedRow?.training || "");
      setValue("description", selectedRow?.description || "");

      // Checkboxes
      setValue("mandatory", !!selectedRow?.mandatory);
      setValue("NABHmandatory", !!selectedRow?.nabhMandatory);
      setValue("JCIMendetory", !!selectedRow?.jciMandatory);
      setValue("preAssNoOfQuestions", selectedRow?.noOfQuestionPreAssessment);
      setValue("postAssNoOfQuestions", selectedRow?.noOfQuestionPostAssessment);

      // NABH fields
      if (selectedRow?.nabhMandatory) {
        setValue("NABHChapter", selectedRow?.nabhChapter || "");
        setValue("NABHClause", selectedRow?.nabhClause || "");
        setValue("NABHDescription", selectedRow?.nabhDescription || "");
        setValue("riskLevel", {
          id: selectedRow?.riskLevelId,
          label: selectedRow?.riskLevel,
          value: selectedRow?.riskLevelId,
        });
      }

      if (selectedRow?.unitId !== null) {
        setValue("unit", {
          id: selectedRow?.unitId,
          label: selectedRow?.unitname,
          value: selectedRow?.unitId,
        });
      }

      setValue("preAssessmentDrop", {
        id: selectedRow?.preAssessmentId,
        label: selectedRow?.preAssessment,
        value: selectedRow?.preAssessmentId,
      });

      setValue("postAssessmentDrop", {
        id: selectedRow?.postAssessmentId,
        label: selectedRow?.postAssessment,
        value: selectedRow?.postAssessmentId,
      });
      // Frequency
      setValue("frequencyType", {
        id: selectedRow?.frequencyTypeId,
        label: selectedRow?.frequencyType,
        value: selectedRow?.frequencyTypeId,
      });

      setValue("frequencyInterval", selectedRow?.frequencyInterval || "");

      setValue("frequencyUnit", {
        id: selectedRow?.frequencyUnitId,
        label: selectedRow?.frequencyUnit,
        value: selectedRow?.frequencyUnitId,
      });

      // Validity & applicability
      setValue("validityPeriod", selectedRow?.validity || "");
      setValue(
        "applicableDepartment",
        selectedRow?.department ? selectedRow?.department : [],
      );

      setValue(
        "applicableRoles",
        selectedRow?.applicableRoles ? selectedRow?.applicableRoles : [],
      );

      // Assessment
      setValue("assessmentReq", !!selectedRow?.assessmentRequired);
      setValue("preAssessment", selectedRow?.preAssessmentRequired === true);
      setValue("postAssessment", selectedRow?.postAssessmentRequired === true);

      // Passing criteria
      setValue("passing", selectedRow?.passing || "");
      setValue("attempts", selectedRow?.maxAttempt || "");

      // Training type
      setValue("trainingType", {
        id: selectedRow?.trainingTypeId,
        label: selectedRow?.trainingType,
        value: selectedRow?.trainingTypeId,
      });

      setUploadedFiles(selectedRow?.trainingDocuments);
    } else {
      reset(defaultValues);
      setUploadedFiles([]);
    }
  }, [selectedRow]);

  // useEffect(() => {
  //   getRiskLevelDropdown()
  //     .then((response) => response?.data)
  //     .then((res) => {
  //       if (res?.statusCode === 200) {
  //         setRiskLevelDropdown(res?.result);
  //       }
  //     })
  //     .catch((error) => errorAlert(error?.message));
  // }, []);
  // useEffect(() => {
  //   getPreAssessmentDropdown()
  //     .then((response) => response?.data)
  //     .then((res) => {
  //       if (res?.statusCode === 200) {
  //         setPreAssessmentDropdown(res?.result);
  //       }
  //     })
  //     .catch((error) => errorAlert(error?.message));
  // }, []);
  // useEffect(() => {
  //   getPostAssessmentDropdown()
  //     .then((response) => response?.data)
  //     .then((res) => {
  //       if (res?.statusCode === 200) {
  //         setPostAssessmentDropdown(res?.result);
  //       }
  //     })
  //     .catch((error) => errorAlert(error?.message));
  // }, []);
  // useEffect(() => {
  //   getFrequencyTypeDropdown()
  //     .then((response) => response?.data)
  //     .then((res) => {
  //       if (res?.statusCode === 200) {
  //         setfrequencyTypeDropdown(res?.result);
  //       }
  //     })
  //     .catch((error) => errorAlert(error?.message));
  // }, []);
  // useEffect(() => {
  //   getFrequencyUnitDropdown()
  //     .then((response) => response?.data)
  //     .then((res) => {
  //       if (res?.statusCode === 200) {
  //         setfrequencyUnitDropdown(res?.result);
  //       }
  //     })
  //     .catch((error) => errorAlert(error?.message));
  // }, []);
  // useEffect(() => {
  //   getTrainingTypeDropdown()
  //     .then((response) => response?.data)
  //     .then((res) => {
  //       if (res?.statusCode === 200) {
  //         setTrainingTypeDropdown(res?.result);
  //       }
  //     })
  //     .catch((error) => errorAlert(error?.message));
  // }, []);

  // useEffect(() => {
  //   getDeptDropdown()
  //     .then((response) => response?.data)
  //     .then((res) => {
  //       if (res?.statusCode === 200) {
  //         setDepartmentDropdown(res?.result);
  //       }
  //     })
  //     .catch((error) => errorAlert(error?.message));
  // }, []);
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [
          riskLevelRes,
          preAssessmentRes,
          postAssessmentRes,
          frequencyTypeRes,
          frequencyUnitRes,
          trainingTypeRes,
          // roleTypeRes,
          unitRes,
          // deptRes,
        ] = await Promise?.all([
          getRiskLevelDropdown(),
          getPreAssessmentDropdown(),
          getPostAssessmentDropdown(),
          getFrequencyTypeDropdown(),
          getFrequencyUnitDropdown(),
          getTrainingTypeDropdown(),
          // getRoleDropdown(),
          getUnitDropdown(),
          // getDeptDropdown(),
        ]);

        if (riskLevelRes?.data?.statusCode === 200) {
          setRiskLevelDropdown(riskLevelRes?.data?.result);
        }

        if (preAssessmentRes?.data?.statusCode === 200) {
          setPreAssessmentDropdown(preAssessmentRes?.data?.result);
        }

        if (postAssessmentRes?.data?.statusCode === 200) {
          setPostAssessmentDropdown(postAssessmentRes?.data?.result);
        }

        if (frequencyTypeRes?.data?.statusCode === 200) {
          setfrequencyTypeDropdown(frequencyTypeRes?.data?.result);
        }

        if (frequencyUnitRes?.data?.statusCode === 200) {
          setfrequencyUnitDropdown(frequencyUnitRes?.data?.result);
        }

        if (trainingTypeRes?.data?.statusCode === 200) {
          setTrainingTypeDropdown(trainingTypeRes?.data?.result);
        }
        // if (roleTypeRes?.data?.statusCode === 200) {
        //   setRoleTypeDropdown(roleTypeRes?.data?.result);
        // }
        if (unitRes?.data?.statusCode === 200) {
          setUnitDropdown(unitRes?.data?.result);
        }

        // if (deptRes?.data?.statusCode === 200) {
        //   setDepartmentDropdown(deptRes?.data?.result);
        // }
      } catch (error) {
        errorAlert(error?.message);
      }
    };

    fetchDropdowns();
  }, []);

  useEffect(() => {
    if (watchUnit?.id) {
      getDepartmentDropdown(watchUnit?.id)
        .then((response) => response?.data)
        .then((res) => {
          if (res?.statusCode === 200) {
            setDepartmentDropdown(res?.result);
          }
        })
        .catch((error) => errorAlert(error?.message));
    }
  }, [watchUnit]);
  useEffect(() => {
    if (
      selectedTrainingType &&
      selectedTrainingType?.label !== "Document" &&
      selectedTrainingType?.label !== "Video"
    ) {
      setUploadedFiles([]);
    }
  }, [selectedTrainingType?.label]);
  return (
    <div>
      <Modal
        open={trainingModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            sx={ModalStyle}
            className="w-[95%]  overflow-y-scroll max-lg:w-[85%] rounded-lg"
          >
            <div className="h-full">
              <div className=" flex justify-between">
                <h1 className="font-semibold text-[17px] ">New Training</h1>
                <div
                  onClick={() => {
                    reset(defaultValues);
                    setUploadedFiles([]);
                    setSelectedRowDetail(null);
                    setSelectedRow(null);
                    setTrainingModalOpen(false);
                  }}
                >
                  <CloseModalIcon type="button" className="closeButton" />
                </div>{" "}
              </div>
              <CommonDivider color="E0E0E0" />
              <div className="mt-3 grid grid-cols-4 gap-3 ">
                <div className="col-span-2 flex gap-2">
                  <DropdownField
                    control={control}
                    name="unit"
                    placeholder="Unit*"
                    dataArray={unitDropDown}
                    isSearchable
                    isClearable
                    error={errors?.unit}
                  />
                  <InputField
                    label="Training Name*"
                    name="training"
                    control={control}
                    error={errors?.training}
                  />
                  <InputField
                    label="Description*"
                    name="description"
                    control={control}
                    error={errors?.description}
                  />
                </div>
                <div className="grid grid-cols-3 col-span-2 gap-2 ">
                  <CheckBoxField
                    control={control}
                    name="mandatory"
                    defaultValue={false}
                    label="Mandatory"
                  />
                  <CheckBoxField
                    control={control}
                    name="NABHmandatory"
                    defaultValue={false}
                    label="NABH Mandatory"
                  />
                  <CheckBoxField
                    control={control}
                    name="JCIMendetory"
                    defaultValue={false}
                    label="JCI Mandatory"
                  />
                </div>

                {NABHmandatory && (
                  <InputField
                    label="NABH Chapter*"
                    name="NABHChapter"
                    control={control}
                    error={errors?.NABHChapter}
                  />
                )}
                {NABHmandatory && (
                  <InputField
                    label="NABH Clause*"
                    name="NABHClause"
                    control={control}
                    error={errors?.NABHClause}
                  />
                )}

                {NABHmandatory && (
                  <InputField
                    label="NABH Description*"
                    name="NABHDescription"
                    control={control}
                    error={errors?.NABHDescription}
                  />
                )}
                {NABHmandatory && (
                  <DropdownField
                    dataArray={riskLevelDropdown}
                    control={control}
                    name="riskLevel"
                    placeholder="Risk Level*"
                    error={errors?.riskLevel}
                    isClearable={true}
                    isSearchable={true}
                    menuPlacement="bottom"
                  />
                )}
                <DropdownField
                  dataArray={frequencyTypeDropdown}
                  control={control}
                  name="frequencyType"
                  placeholder="Frequency Type"
                  error={errors?.frequencyType}
                  isClearable={true}
                  isSearchable={true}
                  menuPlacement="bottom"
                />
                <InputField
                  label="Frequency Interval"
                  name="frequencyInterval"
                  control={control}
                  error={errors?.frequencyInterval}
                />
                <DropdownField
                  dataArray={frequencyUnitDropdown}
                  control={control}
                  name="frequencyUnit"
                  placeholder="Frequency Unit"
                  error={errors?.frequencyUnit}
                  isClearable={true}
                  isSearchable={true}
                  menuPlacement="bottom"
                />
                {/* <DropdownField
                  dataArray={roleTypeDropdown}
                  control={control}
                  name="applicableRoles"
                  placeholder="Applicable Roles"
                  error={errors?.applicableRoles}
                  isClearable={true}
                  isSearchable={true}
                  menuPlacement="bottom"
                  isMulti={true}
                /> */}
                <InputField
                  label="Validity Period(Months)*"
                  name="validityPeriod"
                  control={control}
                  error={errors?.validityPeriod}
                />

                <DropdownField
                  dataArray={departmentDropdown}
                  control={control}
                  name="applicableDepartment"
                  placeholder="Applicable Department"
                  error={errors?.applicableDepartment}
                  isClearable={true}
                  isSearchable={true}
                  menuPlacement="bottom"
                  isMulti={true}
                />
                <CheckBoxField
                  control={control}
                  name="assessmentReq"
                  defaultValue={false}
                  label="Assessment Required"
                />
                {watch("assessmentReq") && (
                  <>
                    <CheckBoxField
                      control={control}
                      name="preAssessment"
                      defaultValue={false}
                      label="Pre Assessment"
                    />
                    {preAssessment && (
                      <div className="grid grid-cols-[70%_30%] gap-1">
                        {" "}
                        <DropdownField
                          dataArray={preAssessmentDropdown}
                          control={control}
                          name="preAssessmentDrop"
                          placeholder="Pre Assessment"
                          error={errors?.preAssessmentDrop}
                          isClearable={true}
                          isSearchable={true}
                          menuPlacement="bottom"
                        />
                        <InputField
                          control={control}
                          name={"preAssNoOfQuestions"}
                          label="No Of Questions"
                        />
                      </div>
                    )}
                    <CheckBoxField
                      control={control}
                      name="postAssessment"
                      defaultValue={false}
                      label="Post Assessment"
                    />
                    {postAssessment && (
                      <div className="grid grid-cols-[70%_30%] gap-1">
                        {" "}
                        <DropdownField
                          dataArray={postAssessmentDropdown}
                          control={control}
                          name="postAssessmentDrop"
                          placeholder="Post Assessment"
                          error={errors?.postAssessmentDrop}
                          isClearable={true}
                          isSearchable={true}
                          menuPlacement="bottom"
                        />
                        <InputField
                          control={control}
                          name={"postAssNoOfQuestions"}
                          label="No Of Questions"
                        />
                      </div>
                    )}
                  </>
                )}
                <div className="flex gap-2">
                  <InputField
                    label="Passing Percentage(%)*"
                    name="passing"
                    control={control}
                    error={errors?.passing}
                  />
                  <InputField
                    label="Max Attempts*"
                    name="attempts"
                    control={control}
                    error={errors?.attempts}
                  />
                </div>
                <DropdownField
                  dataArray={trainingTypeDropdown}
                  control={control}
                  name="trainingType"
                  placeholder="Training Type*"
                  error={errors?.trainingType}
                  isClearable={true}
                  isSearchable={true}
                  menuPlacement="bottom"
                />

                {selectedTrainingType?.label === "Video" && (
                  <div className="col-span-4 mt-2">
                    <label className="text-sm font-medium">Upload Video</label>

                    <input
                      type="file"
                      accept="video/*"
                      multiple
                      onChange={handleFileChange}
                      className="block mt-1"
                    />

                    {uploadedFiles?.length > 0 && (
                      <div className="mt-2 space-y-1 w-[35%] h-[140px] overflow-y-scroll border rounded p-1">
                        {uploadedFiles?.map(
                          (file, index) =>
                            file?.deleteFlag !== true && (
                              <div
                                key={index}
                                className="flex justify-between items-center px-2 py-1 border rounded"
                              >
                                <span className="text-sm truncate">
                                  {file?.fileName || file?.name}
                                </span>

                                <button
                                  type="button"
                                  onClick={() =>
                                    setUploadedFiles((prev) =>
                                      prev?.map((item, i) =>
                                        i === index
                                          ? { ...item, deleteFlag: true }
                                          : item,
                                      ),
                                    )
                                  }
                                  className="text-red-500 text-sm"
                                >
                                  <DeleteIcon />
                                </button>
                              </div>
                            ),
                        )}
                      </div>
                    )}
                  </div>
                )}
                {selectedTrainingType?.label === "Document" && (
                  <div className="col-span-4 mt-2">
                    <label className="text-sm font-medium">
                      Upload Document
                    </label>

                    <input
                      type="file"
                      // accept=".pdf,.doc,.docx"
                      accept=".pdf,.doc,.docx,image/*"
                      multiple
                      onChange={handleFileChange}
                      className="block mt-1"
                    />

                    {uploadedFiles?.length > 0 && (
                      <div className="mt-2 space-y-1 w-[35%] h-[140px] overflow-y-scroll border rounded p-1">
                        {uploadedFiles?.map(
                          (file, index) =>
                            file?.deleteFlag !== true && (
                              <div
                                key={index}
                                className="flex justify-between items-center px-2 py-1 border rounded"
                              >
                                <span className="text-sm truncate">
                                  {file?.fileName || file?.name}
                                </span>

                                <button
                                  type="button"
                                  // onClick={() =>
                                  //   setUploadedFiles((prev) =>
                                  //     prev?.filter((_, i) => i !== index),
                                  //   )
                                  // }
                                  onClick={() =>
                                    setUploadedFiles((prev) =>
                                      prev?.map((item, i) =>
                                        i === index
                                          ? { ...item, deleteFlag: true }
                                          : item,
                                      ),
                                    )
                                  }
                                  className="text-red-500 text-sm"
                                >
                                  <DeleteIcon />
                                </button>
                              </div>
                            ),
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="flex gap-2 mt-2 justify-end">
              <CommonButton
                label="Reset"
                onClick={() => {
                  setSelectedRow(null);
                  reset(defaultValues);
                  setUploadedFiles([]);
                }}
                className="resetButton px-6 py-2 border border-red-500 text-red-500"
              />
              <CommonButton
                label={selectedRow !== null ? "Update" : "Save"}
                type="submit"
                className="saveButton px-6 py-2 bg-green-700 text-white text-base"
              />
            </div>
          </Box>
        </form>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPostModal}
        confirmationHandleClose={() => setOpenPostModal(false)}
        confirmationLabel="Confirmation"
        confirmationMsg={`Are you sure you want to ${
          selectedRow !== null ? "update" : "save"
        } this record?`}
        confirmationSubmitFunc={() => {
          handleSaveRecord();
        }}
        confirmationButtonMsg="Save"
      />
    </div>
  );
};

export default TrainingModal;